module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-menu', [_c('b-menu-list', {
    attrs: {
      "label": "Menu"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "icon": "information-outline",
      "label": "Info"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "settings",
      "active": _vm.isActive,
      "expanded": _vm.isActive
    },
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(props) {
        return [_vm._v("\n                    Administrator\n                    "), _c('b-icon', {
          staticClass: "is-pulled-right",
          attrs: {
            "icon": props.expanded ? 'menu-down' : 'menu-up'
          }
        })]
      }
    }])
  }, [_c('b-menu-item', {
    attrs: {
      "icon": "account",
      "label": "Users"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "cellphone-link"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function(props) {
        return [_vm._v("\n                        Devices\n                        "), _c('b-dropdown', {
          staticClass: "is-pulled-right",
          attrs: {
            "aria-role": "list",
            "position": "is-bottom-left"
          }
        }, [_c('b-icon', {
          attrs: {
            "slot": "trigger",
            "icon": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Action")]), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Another action")]), _vm._v(" "), _c('b-dropdown-item', {
          attrs: {
            "aria-role": "listitem"
          }
        }, [_vm._v("Something else")])], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "cash-multiple",
      "label": "Payments",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "icon": "account",
      "label": "My Account"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "label": "Account data"
    }
  }), _vm._v(" "), _c('b-menu-item', {
    attrs: {
      "label": "Addresses"
    }
  })], 1)], 1), _vm._v(" "), _c('b-menu-list', [_c('b-menu-item', {
    attrs: {
      "label": "Expo",
      "icon": "link",
      "tag": "router-link",
      "target": "_blank",
      "to": "/expo"
    }
  })], 1), _vm._v(" "), _c('b-menu-list', {
    attrs: {
      "label": "Actions"
    }
  }, [_c('b-menu-item', {
    attrs: {
      "label": "Logout"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ba3c0d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/menu/examples/ExSimple.vue
// module id = 1111
// module chunks = 43 122